<template>
	<div class="details">
		<div class="main">
			<div class="title_wrap">
				<h3>{{ detailData.title }}</h3>
				<p>{{ detailData.addTime }}</p>
			</div>
			<div class="ql-editor content" v-html="detailData.content">
				<!-- <p>智慧城市代码标识体系为各个城市及城市管理对象分配统一身份标识，即“数字身份证”，编码结构可实现对标识对象身份信息和属性信息的管理，同时可实现对其它编码结构的兼容。致力于解决城市之间、城市内部各部门、各行业之间的代码统一和数据互通问题，破解数据“共享”与“安全”悖论，是智慧城市建设的基础设施。城市代码标识体系是推动标识代码底层技术服务和新型智慧城市建设相结合的创新实践，为“新基建”提供标识技术支撑,助推城市经济转型升级。</p>
                <img src="./../../../assets/images/home/home_banner.png" alt="">
                <img src="./../../../assets/images/home/home_banner.png" alt="">
                <p>工业和信息化部信息技术发展司巡视员王少朋，北京市经济和信息化局副局长王立勋，河北省工业和信息化厅副厅长任世强，中国工业互联网研究院党委副书记李炜，北京大学人工智能研究院副院长、北京大数据先进技术研究院首席科学家黄罡共同见证平台上线。</p> -->
			</div>
		</div>
	</div>
</template>

<script>
import { contentdetail } from '@/api/home';
export default {
	name: 'Details',
	data() {
		return {
			detailData: {}
		};
	},
	mounted() {
		this.contentdetail();
	},
	methods: {
		contentdetail(id) {
			//通过内容id获取内容详情
			contentdetail({
				id: this.$route.params.id //栏目id
			}).then((res) => {
				// console.log('通过内容id获取内容详情');
				// console.log(JSON.parse(JSON.stringify(res.data)))
				this.detailData = res.data || {};
				// console.log(this.detailData.content,"7878")
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.details {
	width: 100%;
	height: 100%;
	overflow: hidden auto;
	padding-bottom: 84px;
	box-sizing: border-box;
	
	.main {
		width: 1200px;
		margin: 40px auto;
		// border: 1px solid #f00;
		.title_wrap {
			padding: 40px 0;
			box-sizing: border-box;
			text-align: center;
			border-bottom: 1px solid #f2f2f2;
			// border: 1px solid #0f0;
			h3 {
				font-size: 20px;
				color: #000;
			}
			p {
				color: rgba(102, 102, 102, 1);
				font-size: 14px;
				margin-top: 15px;
			}
		}
		.content {
			margin: 45px auto;
			width: 750px;
			overflow: hidden;
			p {
				line-height: 1.5;
			}
			img {
				max-width: 100%;
			}
			::v-deep {
				img {
					width: 100% !important;
					// max-width: 100%;
				}
			}
		}
	}
}
</style>
